export default {
    showLoader() { },

    hideLoader() { },
}